import { ApiError } from '../api/http.ts';

/**
 * Whether a failed mutation should be queued and retried, rather than rolled back.
 *
 * The distinction that matters: the server said no (roll back — retrying will not
 * help), versus we never reached the server (queue it — the user's intent is still
 * valid and they are standing in a shop).
 *
 * `fetch` rejects with a plain TypeError when the network is unreachable, which is why
 * "not an ApiError" is the primary signal. A 5xx or 429 is also worth retrying: the
 * request was understood, the server just could not deal with it yet.
 */
export function isRetryable(error: unknown): boolean {
  if (error instanceof ApiError) {
    return !error.isClientError || error.status === 429;
  }

  // TypeError from fetch, an abort, a DNS failure — anything that means the request did
  // not get an answer.
  return true;
}
